import { Divider } from "antd";
import React from "react"
import { FormularioDeTelefones } from "./FormularioDeTelefones";
import { FormularioDeEmails } from "./FormularioDeEmails";

export const FormularioDeContatos: React.FC<{
    telefonesAPI: React.ComponentProps<typeof FormularioDeTelefones>["telefonesAPI"]
    emailsAPI: React.ComponentProps<typeof FormularioDeEmails>["emailsAPI"]

    permitirEdicaoDosTelefones?: React.ComponentProps<typeof FormularioDeTelefones>["permitirEdicaoDosTelefones"]
    permitirEdicaoDosEmails?: React.ComponentProps<typeof FormularioDeEmails>["permitirEdicaoDosEmails"]
    ocultarDivisores?: boolean 
}> = (props) => {
    const [telefones, setTelefones] = props.telefonesAPI;
    const [emails, setEmails] = props.emailsAPI;

    return <React.Fragment>
        {!props.ocultarDivisores && <Divider>Telefones</Divider>}
        <FormularioDeTelefones telefonesAPI={[telefones, setTelefones]} permitirEdicaoDosTelefones={props.permitirEdicaoDosTelefones} />

        <Divider/>

        {!props.ocultarDivisores && <Divider>E-mails</Divider>}
        <FormularioDeEmails emailsAPI={[emails, setEmails]} permitirEdicaoDosEmails={props.permitirEdicaoDosEmails}/>

    </React.Fragment>

}